import React, {useContext, useState} from 'react';
import logo from '../assets/logo.png'
import {Link, Navigate, useNavigate} from "react-router";
import AuthContext from "../context/AuthProvider";
import axios from "axios";
import {toast} from "react-toastify";
import {BiLoader} from "react-icons/bi";

const EMAIL_ROUTES = {
    "demo@audiotime.com.tr": "/demo",
    "nesine@audiotime.com.tr": "/nesine",
    "hepsiburada@audiotime.com.tr": "/hepsiburada",
    "castroledge@audiotime.com.tr": "/castrol-edge",
    "dyson@audiotime.com.tr": "/dyson",
    "shark@audiotime.com.tr": "/shark",
    "lassa@audiotime.com.tr": "/lassa",
    "petlas@audiotime.com.tr": "/petlas",
    "kocakgold@audiotime.com.tr": "/kocak-gold",
    "aygaz@audiotime.com.tr": "/aygaz",
    "cocacola@audiotime.com.tr": "/cocacola",
    "axess@audiotime.com.tr": "/axess",
    "kupa@audiotime.com.tr": "/kupa",
    "arko@audiotime.com.tr": "/arko",
    "toyota@audiotime.com.tr": "/toyota",
};

function Giris() {
    const {auth, setAuth} = useContext(AuthContext);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [entering, setEntering] = useState(false);
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setEntering(true)
        try {
            const res = await axios.post("https://clerksoftware.com/audiotime.php", {
                password,email
            }, {
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if(res.data.success){
                setAuth(email)
                localStorage.setItem("AudioTimeAuth", email)
                const route = EMAIL_ROUTES[email];
                if (route) navigate(route, { replace: true });
                return null;

            }else{
                setAuth("0")
                toast.error("Girdiğiniz şifre veya email yanlış!")
                localStorage.removeItem("AudioTimeAuth")
            }
            setEntering(false)

        } catch (err) {
            console.error("API hatası:", err);
            setEntering(false)
        }
    };

    const route = EMAIL_ROUTES[auth];
    if (route) return <Navigate to={route} replace />;

    return (
        <section className="account">
            <div className="account__bid">
                <img src="assets/images/thumb/account-bid.png" alt=""/>
            </div>
            <Link to="/" className="account-close" reloadDocument>
                <i className="las la-times"/>
            </Link>
            <div className="account-left">
                <div className="account-left__logo">
                    <Link to={"/"} className="account-left__logo-link" >
                        {" "}
                        <img src={logo} alt=""/>
                    </Link>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <form action="#" autoComplete="off">
                                <h2 className="account-title text-uppercase">
                                    YAPAY ZEKA DEMO GİRİŞ
                                </h2>
                                <div className="row gy-4">

                                    <div className="col-sm-12">
                                        <input
                                            type="email"
                                            className="form--control"
                                            placeholder="Email Address"
                                            onChange={e => setEmail(e.target.value)}
                                            value={email}
                                        />
                                    </div>
                                    <div className="col-sm-12">
                                        <input
                                            type="password"
                                            className="form--control"
                                            placeholder="Şifre"
                                            onChange={e => setPassword(e.target.value)}
                                            value={password}
                                        />
                                    </div>

                                    <div className="col-sm-12">
                                        <p className="contact-content__desc">Demo girişi için kullanıcı bilgileri almak istiyorsanız, <Link style={{color:"#7e2a82"}} to="/iletisime-gecin" reloadDocument>iletişime geçin</Link></p>
                                    </div>
                                    <div className="col-sm-12">
                                        <button type="submit" className="btn--base style-two" onClick={handleSubmit}>
                                            {entering ? <BiLoader className="rotating"/> : "GİRİŞ"}
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="account-right">
                <div className="account-right__thumb">
                    <img src="assets/images/thumb/account-man-img.png" alt=""/>
                </div>
            </div>
        </section>

    );
}

export default Giris;